import Layout from "../Layout";

const Work = () => {
  return (
    <Layout>
      <h1 style={{ margin: "5rem 0", textAlign: "center" }}>Work Page</h1>
    </Layout>
  );
};

export default Work;
